
bq.callbacks.wishlistSuccess = function(json) { //wishlist callback, only on success

  if(json.error === 'true') { return; }

  var selector = false;
  switch(json.action) {
    case "add":
      selector = '.template-menu-'+json.itemId+' .template-menu-item-'+json.wishlistId;
      $(selector).addClass('active');
      $(selector + ' [data-bq="toggle-wishlist"]').data('params', {"wishlist_id": json.wishlistId, "item_id":json.itemId, "wishlist_item_id": json.wishlistItemId});
      break;
    case "remove":
      selector = '.template-menu-'+json.itemId+' .template-menu-item-'+json.wishlistId;
      $(selector).removeClass('active');
      break;
    case "create":

      var allMenus = $('.template-menu');

      $(allMenus).each(function() {
        var itemId = $(this).data("productId");
        var ajaxUrl = $('[data-bq="toggle-wishlist"]', this).data('ajaxUrl');

        $('<a/>', {
          'href': 'javascript:void(0);',
          'text': json.wishlistName,
          'data-bq': 'toggle-wishlist',
          'data-ajax-url': ajaxUrl,
          'data-params': '{"wishlist_id":"'+json.wishlistId+'", "item_id":"'+itemId+'", "wishlist_item_id": ""}',
          'data-form-target': '#product_addtocart_form'
        })
        .wrap('<li class="template-menu-item-'+json.wishlistId+'"></li>')
        .parent()
        .appendTo(this);

      });

      selector = '.template-menu-'+json.itemId+' .template-menu-item-'+json.wishlistId;
      $(selector).toggleClass('active');
      $(selector + ' [data-bq="toggle-wishlist"]').data('params', {"wishlist_id": json.wishlistId, "item_id":json.itemId, "wishlist_item_id": json.wishlistItemId});

      bq.global.registerAjaxActions();
      $('input[name=wishlist_name]').val('');

      break;
    default: //not sure what its sending back, ignore
      break;
  }
};

bq.callbacks.wishlistBeforeAjax = function (params, el, callback) {
    var qty = $('#qty_' + params.item_id).val();
    if ($.inArray(params.action, ['add', 'create']) != -1 && qty) {
        params.qty = qty;
    }
};

bq.callbacks.oneClickOneBeforeRequest = function (params, el, callback) {
    var qty = $('#qty').val();
    if ($.inArray(params.action, ['add']) != -1 && qty) {
        params.qty = qty;
    }
};

bq.callbacks.oneClickValidationRequest = function () {
    var result = true;
    var qtyEl = $('#qty');
    if (qtyEl && qtyEl.data('Parsley')) {
        var validationResult = qtyEl.parsley().validate();
        if (Array.isArray(validationResult) && validationResult.length) {
            result = false;
        }
    }

    return result;
};

bq.callbacks.updateSupplierPaymentValidation = function () {
    var result = true;
    if ($('.row-supplier').find('[data-bq-payment-method-type-radio="credit_card"]').prop('checked')) {
        $('[data-bq="tokenizer-tokenex"]').each(function () {
            var $el = $(this);
            var tokenizer = $el.data('bq.tokenizerTokenex');
            if (!tokenizer || !result || !$el.parent().find('.supplier-payment-card-radio').prop('checked')) {
                return;
            }
            tokenizer.validate();
            result = tokenizer.validation.valid;
        });
    }
    return result;
};

bq.callbacks.updateSupplierBeforeAjax = function (params, el, callback) {
    bq.helper.throwEvent('bq.paymentMethods.preSubmit');
    var self = this;
    var intervalIndex = 0;
    self.canApplyPayments = function() {
        var result = true
        $('[data-bq="payment-creditcards"]:checked').each(function() {
            var $this = $(this);

            // Payment method is not credit card so return
            if (!$this.closest('.row-supplier').find('[data-bq-payment-method-type-radio="credit_card"]').prop('checked')) {
                return;
            }

            var $activeCcHiddenInput = $this.parent().find('.payment-method-cc-hidden-cvv');
            if (!$activeCcHiddenInput.val()) {
                result = false;
            }
        });
        return result;
    };
    var requestInterval = setInterval(function(){
        intervalIndex ++;

        if (intervalIndex > 20) {
            clearInterval(requestInterval);
            console.error('Gateway Timeout');
            return;
        }

        if (self.canApplyPayments()) {
            var formdata = $('#supplier_payment_request_modal :input').serializeArray();
            var data = {};
            $(formdata ).each(function(index, obj){
                data[obj.name] = obj.value;
            });
            Object.assign(params, data);
            editRequest.shouldCancelOnExit = false;
            clearInterval(requestInterval);
            if (typeof callback == "function") {
                callback();
            }
        }
    } ,500);

};

bq.callbacks.qtyUpdateSuccessWishlist = function (json) {

    if (json.error === false && json.product_data) {
        var productData = json.product_data;
        $('#item_' + productData.item_id + ' .item-price .price').html(productData.price);
    }

    bq.helper.throwEvent('bq.notification', $('body'), {
        text: json['message'],
        type: json['error'] ? 'error' : 'success'
    });
};

bq.callbacks.resetForm = function(){
  $(this.formTarget)[0].reset();
};

bq.callbacks.removeCartSuccess = function(json){
    if (json.quote.summary_qty == 0 && json.quote.empty_html) {
        $('.main-content').html(json.quote.empty_html);
    } else {
        for (var itemId in json.item) {
            if (json.item[itemId].error !== 'true') {
                $('.cart-item-link-id-' + itemId).remove();
                $('#cart_item_' + itemId).remove();
            }
        }
        $('.shopping-cart-totals .summary-total').html(json.quote.grand_total_html);
        $('.shopping-cart-totals .summary-count').html(numberFormat(json.quote.summary_qty));
        $.each(json.quote.budgets, function (itemId, budgetHtml) {
            $('#cart_item_' + itemId + ' .budget').html(budgetHtml);
        });
        if (!json.quote.has_error) {
            $('ul.messages>li.error-msg').css('display', 'none');
            var isMiniCart= $('.cart-table').size() <= 0;
            if (!isMiniCart && $('.cart-table').closest('form').parsley() && $('.cart-table').closest('form').parsley().validate()) {
              $('button.go-checkout').attr('disabled',null);
          }
        } else {
            $('button.go-checkout').css('display','none');
            bq.helper.modal.create('', '', '', bq.messages.global.loading, '', '', '');
            location.reload();
            return;
        }
  }

  bq.helper.throwEvent('bq.ajaxAction.cart.update', $('.top-bar-nav .mini-cart-link'));
};

bq.callbacks.addCartSuccess = function (json) {
    bq.global.noInitJS = true;
    bq.helper.throwEvent('bq.ajaxAction.cart.update', $('.top-bar-nav .mini-cart-link'));

    var dropdownElement = $('#topbar .mini-cart-link > a');
    var switchElement = dropdownElement.closest('li');
    clearTimeout(bq.timeoutShowCart);
    clearTimeout(bq.timeoutHideCart);

    if (bq.config.growl.cart && bq.config.growl.cart != 'false' && bq.config.growl.cart > 1) {
        // SCROLL TO TOP
        var showDelay = bq.config.growl.cart;
        $('html, body').animate({scrollTop: 0}, 1500);
        // SHOW CART
        bq.timeoutShowCart = setTimeout(function () {
            //if cart is not open
            if (!$(switchElement).hasClass('open')) {
                $(dropdownElement).dropdown('toggle');
            }

            // HIDE CART AFTER bq.config.growl.delay
            var cartTime = bq.config.growl.delay;
            bq.timeoutHideCart = setTimeout(function () {
                //if cart is open
                if ($(switchElement).hasClass('open')) {
                    $(dropdownElement).dropdown('toggle');
                }
            }, cartTime);
        }, showDelay);
    }
    if (json.quote) {
        $('.shopping-cart-totals .summary-total').html(json.quote.grand_total_html);
        $('.shopping-cart-totals .summary-count').html(numberFormat(json.quote.summary_qty));
    }
    if (json.itemRowHtml && json.quoteItemId) {
        var itemSelector = '#cart_item_' + json.quoteItemId;
        if ($(itemSelector).length) {
            $(itemSelector).replaceWith(json.itemRowHtml);
        } else {
            if ($('.cart-table>.count-rows>tbody').length)
                $('.cart-table>.count-rows>tbody').append(json.itemRowHtml);
        }
    }
    if ($('#product_addtocart_form').length && $('#bundle').length) {
        $('#product_addtocart_form').trigger('reset');
        $('#product_addtocart_form').find('.cart-item-linked-bubble').each(function() {
            if ($(this).hasClass('active')) {
                $('.' + $(this).data('popup-class')).first().slideToggle();
                $(this).removeClass('active');
            }
        });
        $('#product_addtocart_form').find('.bundle-option-image-select').each(function() {
            if (!$(this).hasClass('hidden')) {
                $(this).addClass('hidden')
            }
        });
        $('[data-bq="product-price"]').trigger('change');

        if ($('#bundle').length) {
          $('#bundle').trigger('reset');
        }
    }
    setTimeout(function () {
      bq.global.imageLoader();
      bq.global.noInitJS = false;
    }, 0);
};

bq.callbacks.oneClickRequestSuccess = function(json, el) {
  if (json.message) {
    bq.helper.throwEvent('bq.notification', null, {
      id: 'notification_' + $(el).attr('id'),
      text: json.message,
      type: json.error === true || json.error === 'true' ? 'error' : 'success',
      hide: false
    });
  } else {
    bq.helper.throwEvent('bq.removeNotification', null, {
      id: 'notification_' + $(el).attr('id')
    });
  }

  $(el).prev('button.btn').removeAttr('disabled').removeClass('disabled');
  $(el).removeAttr('disabled').removeClass('disabled');
};

bq.callbacks.updateDefaultLocationRequestSuccess = function(json, el) {
  bq.helper.throwEvent('bq.notification', null, {
    id: 'notification_' + $(el).attr('id'),
    text: json.message,
    type: json.error === true || json.error === 'true' ? 'error' : 'success',
    hide: !json.error
  });

  $(el).closest('.pull-right').find('a, button').removeClass('disabled');
  $(el).closest('.pull-right').find('a, button').removeAttr('disabled');

  if (json.success === true) {
    if ($(el).closest('.select-group').length > 0) {
      bq.helper.throwEvent('bq.selectboxdata.enableSelectBox', $(el).closest('.select-group').find('[data-bq="selectbox-data"]'));
    }
    $(el).closest('.default-' + json.type + '__container').html(json.data);
  }
};

bq.callbacks.removeDefaultBillingRequestSuccess = function(json, el) {
  bq.helper.throwEvent('bq.notification', null, {
    id: 'notification_' + $(el).attr('id'),
    text: json.message,
    type: json.error === true || json.error === 'true' ? 'error' : 'success',
    hide: !json.error
  });

  if (json.success === true) {
    $(el).closest('.default-billing__container').html(json.data);
  }
};

bq.callbacks.compareAlways = function(data, textStatus, jqXHR) {
  if(data.count) {
    if(data.count >= bq.config.compareLimit) {
      $('[data-bq="toggle-compare"]').parents('.input-parent').addClass('overLimit');
    } else {
      $('[data-bq="toggle-compare"]').parents('.input-parent').removeClass('overLimit');
    }
  }

  $('.compare_tn_' + data.itemId).each(function () {
    var $checkbox = $(this);
    if (($checkbox.is(':checked') && data.action == 'remove') || (!$checkbox.is(':checked') && data.action == 'add')) {
      bq.helper.toggleCheckbox('#' + $checkbox.attr('id'), true);
      var ajaxActions = $checkbox.data('bq.ajaxAction');
      if(ajaxActions) {
        ajaxActions._callBackAlways({error: false});
      }
    }
  });

  //global change of active status
  $('[data-bq="toggle-compare"]:checked').parent('.input-parent').addClass('checked');
  $('[data-bq="toggle-compare"]').not(':checked').parent('.input-parent').removeClass('checked');

  var compareLink = $('.compare-link-action');
  if (compareLink.length) {
    if (data.count) {
      compareLink.show().find('.count').html(data.count);
      compareLink.siblings().hide();
    } else {
      compareLink.hide();
      compareLink.siblings().show();
    }
  }
};

bq.callbacks.tagAlways = function(data) {

    var $button = $('[data-bq="' + this.bq + '"]').filter('[data-product-id="' + this.productId + '"]');
    var $parent = $button.parent(),
        params  = $button.data('params'),
        activeClassName = 'active';

    $parent.toggleClass(activeClassName);

    if( $parent.hasClass(activeClassName) ) {

        // product was added
        $button.text( $button.data('text-bq-remove-tag') );
        params.tagId = data.id;
    } else {

        // product was removed
        $button.text( $button.data('text-bq-add-tag') );
        delete params.tagId;
    }
};

bq.callbacks.qtyUpdateSuccess = function(json) {
    if(json.error === 'true' || json.forward) { return; }
    jQuery.each(json.updated_items, function(idx, item) {
        var cartRow = $('#cart_item_'+item.item_id);
        $('.cart-price.price > .price', cartRow).html(item.price_html);
        $('.cart-price.price.item-total', cartRow).html(item.row_total_html);
        $('input.qty', cartRow).val(item.item_qty);
    });
    $('.shopping-cart-totals .summary-total').html(json.quote.grand_total_html);
    $('.shopping-cart-totals .summary-count').html(numberFormat(json.quote.summary_qty));
    $.each(json.quote.budgets, function (itemId, budgetHtml) {
        $('#cart_item_' + itemId + ' .budget').html(budgetHtml);
    });
    if(!json.quote.has_error){
      $('ul.messages>li.error-msg').css('display', 'none');
      if($('.cart-table').closest('form').parsley().validate()){
        $('button.go-checkout').attr('disabled',null);
      }
    }else{
      $('button.go-checkout').css('display','none');
      bq.helper.modal.create('', '', '', bq.messages.global.loading, '', '', '');
      location.reload();
      return;
    }
    bq.helper.throwEvent('bq.ajaxAction.cart.update', $('.top-bar-nav .mini-cart-link'));
};

bq.callbacks.changeOrderQtyUpdateSuccess = function(json) {
    var dependantValidationSelectors = ['.item-verifier'];
    var dependantValidationViolations = 0;
    if(json.error === 'true' || json.forward) { return; }
    $.each(json.quote.items, function(idx, item) {
        var $row = $("#co-line-item-" + item.item_id);
        var $extraRow = $('#co-extra-line-item-' + item.item_id);
        $extraRow.find(dependantValidationSelectors.join(',')).each(function(i, field) {
            if (['INPUT', 'SELECT'].indexOf(field.nodeName) === -1) {
                return;
            }
            var result = $(field).parsley().validate();
            if (result.length) {
                dependantValidationViolations += result.length;
            }
        });

        if (dependantValidationViolations > 0) { return; }

        var $itemTotal = $row.find('.item-total');
        var productPriceFormat = $.extend({}, editRequest.priceFormat);
        productPriceFormat.pattern = item.currency_symbol + '%s';
        productPriceFormat.round = true;

        if (item.item_removed) {
            $row.addClass('removed-item');
            $row.find('input.qty').val(0).prop('readonly', 'readonly');
            $row.find('.col-uom').html('N/A');
            $row.find('.col-price').html('<span>N/A</span>');
            var hiddenInput = $('<input>').prop({
                type: 'hidden',
                id: 'items[' + item.item_id + '][is_deleted]',
                name: 'items[' + item.item_id + '][is_deleted]',
                value: 1
            });
            $row.find('.col-action').html(hiddenInput);
            $itemTotal.html(json.message);
        } else if (item.item_qty !== undefined) {
            $row.find('input.qty').val(item.item_qty);
            $itemTotal.find('.price').html(formatCurrency(item.item_total, productPriceFormat));
        }
    });
    var totalPriceFormat = $.extend({}, editRequest.priceFormat);
    totalPriceFormat.round = true;

    editRequest.updateGrandTotals({
        grand_total_html: formatCurrency(json.quote.grand_total, totalPriceFormat)
    });
};

bq.callbacks.changeOrderPriceUpdateSuccess = function(json) {
    if (json.error === 'true' || json.error === true || json.forward) {
        return;
    }
    var $row = $("#co-line-item-" + json.quote.item_id);
    var dependantValidationSelectors = ['.item-verifier'];
    var dependantValidationViolations = 0;
    var $extraRow = $('#co-extra-line-item-' + json.quote.item_id);
    $extraRow.find(dependantValidationSelectors.join(',')).each(function(i, field) {
        if (['INPUT', 'SELECT'].indexOf(field.nodeName) === -1) {
            return;
        }
        var result = $(field).parsley().validate();
        if (result.length) {
            dependantValidationViolations += result.length;
        }
    });

    if (dependantValidationViolations > 0) { return; }

    var $itemTotal = $row.find('.item-total');
    var productPriceFormat = $.extend({}, editRequest.priceFormat);
    productPriceFormat.pattern = json.quote.currency_symbol + '%s';

    $row.find('input.qty').val(json.quote.item_qty);
    $itemTotal.find('.price').html(formatCurrency(json.quote.item_total, productPriceFormat));

    editRequest.updateGrandTotals({
        grand_total_html: formatCurrency(json.quote.grand_total, editRequest.priceFormat)
    });
};

bq.callbacks.supplierFavAlways = function (data, textStatus, jqXHR) {

    // check for ie11
    if (!(window.ActiveXObject) && "ActiveXObject") {
        // because of IE bug https://github.com/twbs/bootstrap/issues/14211
        // we fix it by trigger "click" event
        $(document).click();
    }

    var $elem  = $('#toggle-fav-supplier-' + data.id),
        titles = $elem.data('titles');
    if (data.error) return;
    if (data.action == 'add') {
        $elem.parent().addClass('active');
    } else {
        $elem.parent().removeClass('active');
    }
    $elem.attr('title', titles[data.action]).tooltip('fixTitle');
};

bq.callbacks.locationFavCallBefore = function(params, el) {
  var selectBox = $(el).closest('[data-bq="selectbox-data"]');

  if (selectBox.length > 0) {
    var parent = selectBox.data('update-selection');

    $(parent).addClass('location-disabled');
  }
};

bq.callbacks.locationFavAlways = function(data, textStatus, jqXHR){

  var allFavs = '[data-bq="toggle-fav-location"][data-param-id="' + data.id + '"]';
  if(data.error && data.error == 'true' || !data.id) return;


  $(allFavs).each(function(){
    var el = $(this),
        titles = el.data('titles'),
        addText = el.attr('data-add-text'),
        remText = el.attr('data-remove-text');

        if(data.action == 'add'){
            el.parent().addClass('active');
            if(remText){
              el.text(remText);
            }

        } else {
            el.parent().removeClass('active');
            if(addText){
              el.text(addText);
            }
        }

        if(titles) {
          el.attr('title', titles[data.action]).tooltip('fixTitle');
        }


        // clear drop-down value
        //bq.helper.throwEvent('bq.selectboxdata.updateValue', el.closest('.shipping-select-box'), '');


  });

  if ($(allFavs).closest('.location-disabled').length > 0) {
      $(allFavs).closest('.location-disabled').removeClass('location-disabled');
  }

  if (data.locations && data.locations.results) {
      // Update header shipping list
      var headerSelectBox = $('[data-bq="selectbox-data"]', '[data-bulk-container="bulk_edit_shipping"]');
      headerSelectBox.each(function () {
          var value = $(this).find('.shipping_address_id').val();
          bq.helper.throwEvent('bq.selectboxdata.update', $(this), data.locations);
          bq.helper.throwEvent('bq.selectboxdata.updateValue', $(this), value);
      });
      // Update line shipping list
      var lineSelectBoxes = $('[data-bq="selectbox-data"]', '.onepage-line-edit-shipping-mode .shipping');
      lineSelectBoxes.each(function () {
          var value = $(this).find('.shipping_address_id').val();
          bq.helper.throwEvent('bq.selectboxdata.update', $(this), data.locations);
          bq.helper.throwEvent('bq.selectboxdata.updateValue', $(this), value);
      });
  }
};

bq.callbacks.accountingDefaultAlways = function (data, textStatus, jqXHR) {

    if(data.error || !data.id) return;

    if(!data.error) {
        var prevDefaultAccounting = $('#account-accounting-listing .accounting-default').first();
        var selectedAccounting = $('[data-accounting-id="' + data.id + '"]').first();
        var defaultAccountingHeading = $('.accounting-default .accounting-heading').first();

        //show-hide make default accounting link
        $('li .accounting-default-link [data-param-id="' + data.id + '"]').parents('li').hide();
        $(prevDefaultAccounting).find('.accounting-default-link').parents('li').show();

        //update accounting-default
        $(prevDefaultAccounting).removeClass('accounting-default');
        $(selectedAccounting).addClass('accounting-default');

        // move default accounting header
        var header = document.createElement('em');
        header.innerText = bq.config.text.accountingDefaultHeader;
        $(header).addClass('block-heading accounting-heading address-heading');
        $('[data-accounting-id="' + data.id + '"] > strong').after(header);
        defaultAccountingHeading.remove();
    }
};

bq.callbacks.compareRemoveAll = function(data) {
  $('[data-bq="toggle-compare"]').each(function () {
    if ( $(this).parents('.input-parent').hasClass('checked') ) {
      var elem = '#' + $(this).attr('id');
      bq.helper.toggleCheckbox(elem, true);
      $(this).parent().removeClass('checked');
      $(elem).data('bq.ajaxAction').options.toggle = 'remove';
      $(elem).data('bq.ajaxAction').options.type = 'add';
    }
  });
  $('[data-bq="toggle-compare"]').parents('.input-parent').removeClass('overLimit');
  data.count = 0;
};

bq.callbacks.validateInvoiceNumber = function (data) {
    if (data.error && data.message) {
        bq.helper.throwEvent('bq.notification', $(document), {
            id:   'notification_bq-ui-1',
            text: data.message,
            type: 'error'
        });
    }

    if (this.eventName === 'focusout') jQuery(this.selector).focus();
};

bq.callbacks.invoicingRemoveItem = function (data) {
    if (!data['error']) {
        var lineId = data['line_id'];
        ['item', 'item-more', 'item-detail'].each(function (key) {
            jQuery('#invoice-' + key + '-' + lineId).remove();
        });
        jQuery('.invoice-item-row').each(function (index) {
            var $row = jQuery(this);
            var oldLine = $row.data('lineid');
            var newLine = index + 1;
            if (oldLine != newLine) {
                $row.data('lineid', newLine);
                $row.find('.invoice-line-number').html(newLine);
                $row.find('[name]').each(function () {
                    var input = jQuery(this);
                    var name = input.attr('name');
                    input.attr('name', name.replace('[' + oldLine + ']', '[' + newLine + ']'));
                });
            }
        });
        invoicing_refresh_header_level_input_data('subtotal');
        invoicing_update_total();
    }
};

bq.callbacks.accountFavSuccess = function(json, el) {
    if (!json.accounts || !json.accounts.results) {
        return ;
    }
    //update fav accounting selec-boxes with new results
    $('.accounting-fav-select-box[data-bq="selectbox-data"]').each(function () {
        var sel = $(this).data('bq.selectboxData');
        var data = sel.options.initData;
        //add new items latest in list
        $(json.accounts.results).each(function(index, item) {
            data.results.push(item);
        });
        //refresh select-box
        bq.helper.throwEvent('bq.selectboxdata.update', $(this), data);
    });
    //set current value in one select-box - related to "Save" button
    if (el && json.accounts.results[0] && json.accounts.results[0].id) {
        var form = $(el).closest('[data-bq="accounting"]');
        $(form).find('.accounting-fav-select-box[data-bq="selectbox-data"]').each(function () {
            bq.helper.throwEvent('bq.selectboxdata.updateValue', $(this), json.accounts.results[0].id);
        });
    }
};

bq.callbacks.fromRequest = function() {
  $("#form-request-wrapper").hide();
};

bq.callbacks.deliveryToUpdate = function (data) {
    if(!data.error) {
        if (data.deliver_to !== '') {
            $('#deliver-to-text span').removeClass('input-blank').text(data.deliver_to);
        } else {
            var emptyHtml = $('<em/>').text(data.empty_message);
            $('#deliver-to-text span').addClass('input-blank').html(emptyHtml);
        }

        bq.helper.showAndHide('#deliver-to-text', '#deliver-to-form');
    }
};

bq.callbacks.addCartAroundAjax = function ($this, params, el) {
    bq.helper.timeoutAjaxProcess($this, params, el);
    return true;
};

bq.callbacks.updateDefaultLocationAroundAjax = function ($this, params, el) {
  $(el).closest('.pull-right').find('a, button').addClass('disabled');
  $(el).closest('.pull-right').find('a, button').attr('disabled', 'disabled');

  if ($(el).closest('.select-group').length > 0) {
    bq.helper.throwEvent('bq.selectboxdata.disableSelectBox', $(el).closest('.select-group').find('[data-bq="selectbox-data"]'));
  }

  bq.helper.timeoutAjaxProcess($this, params, el);
  return true;
};

bq.callbacks.addCartPrepareRequest = function (params, localElementStorage) {
    var ajaxRequest = params;
    var items = {};
    for (var element in localElementStorage) {
      items[localElementStorage[element].params.id] = localElementStorage[element].params.qty || 1;
    }
    ajaxRequest['items'] = JSON.stringify(items);

    ajaxRequest['action'] = 'addMultiple';
    delete ajaxRequest['id'];
    delete ajaxRequest['qty'];

    return ajaxRequest;
};

bq.callbacks.oneClickPrepareRequest = function (params) {
  return {
    qty: params.qty,
    id: params.id
  }
};

bq.callbacks.addSubscriptionSuccess = function (json) {
    if (!json.error) {
      bq.callbacks.addCartSuccess(json);

      var messageBlock = jQuery('#messages-bar');
      if (messageBlock.length && json.message) {
        messageBlock.empty();
        messageBlock.append(json.message);
      }
    }
};

bq.callbacks.addSubscriptionAroundAjax = function ($this, params, el) {
    bq.helper.timeoutAjaxProcess($this, params, el);
    return true;
};

bq.callbacks.addSubscriptionPrepareRequest = function (params, localElementStorage) {
    var ajaxRequest = params;
    var items = {};
    for (var element in localElementStorage) {
        items[localElementStorage[element].params.id] = localElementStorage[element].params.qty || 1;
    }
    ajaxRequest['items'] = JSON.stringify(items);
    ajaxRequest['action'] = 'addMultiple';
    return ajaxRequest;
};

bq.callbacks.updateDefaultLocationPrepareRequest = function (params, localElementStorage) {
  var type;

  for (var element in localElementStorage) {
    type = localElementStorage[element].element.$element.data('type');
  }

  return $.extend(params, {type: type});
};

bq.callbacks.removeCartAroundAjax = function ($this, params, el) {
    bq.helper.timeoutAjaxProcess($this, params, el);
    return true;
};

bq.callbacks.removeCartPrepareRequest = function (params, localElementStorage) {
    var ajaxRequest = params;
    var items = {};
    for (var element in localElementStorage) {
        items[localElementStorage[element].params.id] = localElementStorage[element].params;
    }
    ajaxRequest['items'] = JSON.stringify(items);
    ajaxRequest['action'] = 'removeMultiple';
    delete ajaxRequest['id'];

    return ajaxRequest;
};

bq.callbacks.changeOrderQtyPriceValidationFail = function(element) {
    var invalidFields = $('.form-validation-error');
    if (invalidFields.length >= 1) {

        var field = invalidFields.first();
        var rowDetails = field.closest('.line-item-row-details');
        if (rowDetails.length === 1) {
            rowDetails.css('display', 'table-row');
            $('html, body').animate({
                scrollTop: field.offset().top
            }, 500);
        }
    }
};

bq.callbacks.updateSupplierPaymentInfoSuccess = function(element) {
    jQuery('#supplier_payment_request_modal').modal('hide');
};

bq.global.ajaxActions.options = {
  addCart: {
    selector: '[data-bq="add-cart"]',
    options: $.extend({type: 'add', highlightSuccess: true, ajaxUrl: bq.urls.ajax.cart, callbackSuccess: bq.callbacks.addCartSuccess,
        callAroundAjax: bq.callbacks.addCartAroundAjax, prepareAroundRequest: bq.callbacks.addCartPrepareRequest}, bq.messages.ajaxActions.cart)
  },
   removeCart: {
    selector: '[data-bq="remove-cart"]',
    options: $.extend({type: 'remove', ajaxUrl: bq.urls.ajax.cart, callbackSuccess: bq.callbacks.removeCartSuccess,
        callAroundAjax: bq.callbacks.removeCartAroundAjax, prepareAroundRequest: bq.callbacks.removeCartPrepareRequest},bq.messages.ajaxActions.cart)
  },
  updateCart: {
    selector: '[data-bq="update-cart"]',
    options: $.extend({type: 'update', highlightSuccess: true, ajaxUrl: bq.urls.ajax.cart, callbackSuccess: bq.callbacks.addCartSuccess}, bq.messages.ajaxActions.cart)
  },
  qtyUpdate: {
    selector: '[data-bq="update-qty"]',
    options: $.extend({type: 'update', eventName: 'focusout', notificationInline: true, ajaxUrl: bq.urls.ajax.cart, callbackSuccess: bq.callbacks.qtyUpdateSuccess}, bq.messages.ajaxActions.cartqty)
  },
  addSearch: {
    selector: '[data-bq="add-search"]',
    options: $.extend({type: 'add', ajaxUrl: bq.urls.ajax.search, callbackSuccess : bq.callbacks.resetForm}, bq.messages.ajaxActions.search)
  },
  removeSearch: {
    selector: '[data-bq="remove-search"]',
    options: $.extend({type: 'remove', ajaxUrl: bq.urls.ajax.search}, bq.messages.ajaxActions.search)
  },
  addReview: {
    selector: '[data-bq="add-review"]',
    options: $.extend({type: 'add', ajaxUrl: bq.urls.ajax.review, callbackSuccess : bq.callbacks.resetForm}, bq.messages.ajaxActions.review)
  },
  removeReview: {
    selector: '[data-bq="remove-review"]',
    options: $.extend({type: 'remove', ajaxUrl: bq.urls.ajax.review}, bq.messages.ajaxActions.review)
  },
  toggleWishlist: {
    selector: '[data-bq="toggle-wishlist"]',
    options: $.extend({type: 'add', toggle: 'remove', ajaxUrl: bq.urls.ajax.wishlist, callBeforeAjax: bq.callbacks.wishlistBeforeAjax, callbackSuccess: bq.callbacks.wishlistSuccess}, bq.messages.ajaxActions.wishlist)
  },
  createWishlist: {
    selector: '[data-bq="create-wishlist"]',
    options: $.extend({type: 'add', ajaxUrl: bq.urls.ajax.wishlist, callBeforeAjax: bq.callbacks.wishlistBeforeAjax, callbackSuccess: bq.callbacks.wishlistSuccess}, bq.messages.ajaxActions.wishlist)
  },
  qtyUpdateWishlist: {
    selector: '[data-bq="update-qty-wishlist"]',
    options: $.extend({type: 'update', eventName: 'focusout', notificationInline: true, ajaxUrl: bq.urls.ajax.wishlist, callbackSuccess: bq.callbacks.qtyUpdateSuccessWishlist}, bq.messages.ajaxActions.wishlist)
  },
  toggleCompare: {
    selector: '[data-bq="toggle-compare"]',
    options: $.extend({type: 'add', toggle: 'remove', ajaxUrl: bq.urls.ajax.compare, callbackAlways: bq.callbacks.compareAlways}, bq.messages.ajaxActions.compare)
  },
  toggleTag: {
    selector: '[data-bq="toggle-tag"]',
    options: $.extend({type: 'add', toggle: 'remove', ajaxUrl: bq.urls.ajax.tag, callbackAlways: bq.callbacks.tagAlways}, bq.messages.ajaxActions.tag)
  },
  removeCompare: {
    selector: '[data-bq="remove-compare"]',
    options: $.extend({type: 'remove', ajaxUrl: bq.urls.ajax.compare, callbackAlways: bq.callbacks.compareAlways}, bq.messages.ajaxActions.compare)
  },
  removeAllCompare: {
    selector: '[data-bq="remove-all-compare"]',
    options: $.extend({type: 'removeAll', ajaxUrl: bq.urls.ajax.compare, callbackAlways: bq.callbacks.compareRemoveAll}, bq.messages.ajaxActions.compare)
  },
  validateInvoiceNumber: {
    selector: '[data-bq="validate-invoice-number"]',
    options: $.extend({type: 'validate_invoice_number', eventName: 'focusout', validateSelectorField: true, notificationInline: true, ajaxUrl: bq.urls.ajax.invoicing, callbackAlways: bq.callbacks.validateInvoiceNumber}, bq.messages.ajaxActions.invoicing)
  },
  removeItem: {
    selector: '[data-bq="invoicing-remove-item"]',
    options: $.extend({type: 'remove_item', ajaxUrl: bq.urls.ajax.invoicing, callbackAlways: bq.callbacks.invoicingRemoveItem}, bq.messages.ajaxActions.invoicing)
  },
  toggleSupplierFav: {
    selector: '[data-bq="toggle-fav-supplier"]',
    options: $.extend({type: 'add', toggle: 'remove', ajaxUrl: bq.urls.ajax.supplierFav, callbackAlways: bq.callbacks.supplierFavAlways }, bq.messages.ajaxActions.supplierFav)
  },
  toggleLocationFav: {
    selector: '[data-bq="toggle-fav-location"]',
    options: $.extend({type: 'add', toggle: 'remove', ajaxUrl: bq.urls.ajax.locationFav, callbackAlways: bq.callbacks.locationFavAlways, callBeforeAjax: bq.callbacks.locationFavCallBefore}, bq.messages.ajaxActions.locationFav)
  },
  toggleAccountingDefault: {
      selector: '[data-bq="toggle-default-accounting"]',
      options: $.extend({type: 'add', toggle: 'remove', ajaxUrl: bq.urls.ajax.accountingDefault, callbackAlways: bq.callbacks.accountingDefaultAlways}, bq.messages.ajaxActions.accountingDefault)
  },
  removeEntitySearch: {
    selector: '[data-bq="remove-entitysearch"]',
    options: $.extend({type: 'remove', ajaxUrl: bq.urls.ajax.entitySearch}, bq.messages.ajaxActions.entitySearch)
  },
  saveAccountFav: {
    selector: '[data-bq="save-favacc"]',
    options: $.extend({type: 'add', ajaxUrl: bq.urls.ajax.accountFav, callbackSuccess: bq.callbacks.accountFavSuccess}, bq.messages.ajaxActions.accountFav)
  },
  fromRequest: {
    selector: '[data-bq="from-request"]',
    options: $.extend({type: 'add', ajaxUrl: bq.urls.ajax.fromRequest, callbackAlways: bq.callbacks.fromRequest}, bq.messages.ajaxActions.fromRequest)
  },
  removeAvatar: {
    selector: '[data-bq="remove-avatar"]',
    options: $.extend({type: 'remove', ajaxUrl: bq.urls.ajax.avatar, callbackSuccess: bq.callbacks.removeAvatar}, bq.messages.ajaxActions.avatar)
  },
  saveDeliveryTo: {
    selector: '[data-bq="save-delivery-to"]',
    options: $.extend({type: 'update', ajaxUrl: bq.urls.ajax.deliveryTo, callbackAlways: bq.callbacks.deliveryToUpdate}, bq.messages.ajaxActions.deliveryTo)
  },
   updateProductContent: {
    selector: '[data-bq="update-product-content"]',
    options: $.extend({type: 'update', ajaxUrl: bq.urls.ajax.contentCuration, callbackSuccess : bq.callbacks.resetForm}, bq.messages.ajaxActions.contentCuration)
  },
  validateInvoiceNumberCreateForm: {
   selector: '[data-bq="validate-invoice-number-create-form"]',
   options: $.extend({type: 'validate_invoice_number', eventName: 'focusout', validateSelectorField: true, notificationInline: true, ajaxUrl: bq.urls.ajax.invoiceNumberCreateForm, callbackAlways: bq.callbacks.validateInvoiceNumber}, bq.messages.ajaxActions.invoicing)
  },
  validateCreditMemoNumber: {
    selector: '[data-bq="validate-credit-memo-number"]',
    options: $.extend({type: 'validate_credit_memo_number', selector: '[data-bq="validate-credit-memo-number"]', eventName: 'focusout', validateSelectorField: true, notificationInline: true, ajaxUrl: bq.urls.ajax.validateCreditMemoNumber, callbackAlways: bq.callbacks.validateInvoiceNumber}, bq.messages.ajaxActions.creditMemo)
  },
  changeOrderQtyUpdate: {
      selector: '[data-bq="change-order-update-qty"]',
      options: $.extend({type: 'update', eventName: 'focusout', notificationInline: true, ajaxUrl: bq.urls.ajax.changeOrderQtyUpdate, callbackSuccess: bq.callbacks.changeOrderQtyUpdateSuccess, callbackValidationFail: bq.callbacks.changeOrderQtyPriceValidationFail, validateSelectorField: true}, bq.messages.ajaxActions.cartqty)
  },
  changeRequestQtyUpdate: {
      selector: '[data-bq="change-request-update-qty"]',
      options: $.extend({type: 'update', eventName: 'focusout', notificationInline: true, ajaxUrl: bq.urls.ajax.changeRequestQtyUpdate, callbackSuccess: bq.callbacks.changeOrderQtyUpdateSuccess}, bq.messages.ajaxActions.cartqty)
  },
  editRequestQtyUpdate: {
      selector: '[data-bq="edit-request-update-qty"]',
      options: $.extend({type: 'update', eventName: 'focusout', notificationInline: true, ajaxUrl: bq.urls.ajax.editRequestQtyUpdate, callbackSuccess: bq.callbacks.changeOrderQtyUpdateSuccess, callbackValidationFail: bq.callbacks.changeOrderQtyPriceValidationFail}, bq.messages.ajaxActions.cartqty)
  },
  approverEditRequestQtyUpdate: {
      selector: '[data-bq="approver-edit-request-update-qty"]',
      options: $.extend({type: 'update', eventName: 'focusout', notificationInline: true, ajaxUrl: bq.urls.ajax.approverEditRequestQtyUpdate, callbackSuccess: bq.callbacks.changeOrderQtyUpdateSuccess, callbackValidationFail: bq.callbacks.changeOrderQtyPriceValidationFail}, bq.messages.ajaxActions.cartqty)
  },
  changeOrderPriceUpdate: {
      selector: '[data-bq="change-order-update-price"]',
      options: $.extend({type: 'update', eventName: 'focusout', notificationInline: true, ajaxUrl: bq.urls.ajax.changeOrderPriceUpdate, callbackSuccess: bq.callbacks.changeOrderPriceUpdateSuccess, callbackValidationFail: bq.callbacks.changeOrderQtyPriceValidationFail, validateSelectorField: true}, bq.messages.ajaxActions.cartqty)
  },
  changeRequestPriceUpdate: {
      selector: '[data-bq="change-request-update-price"]',
      options: $.extend({type: 'update', eventName: 'focusout', notificationInline: true, ajaxUrl: bq.urls.ajax.changeRequestPriceUpdate, callbackSuccess: bq.callbacks.changeOrderPriceUpdateSuccess}, bq.messages.ajaxActions.cartqty)
  },
  editRequestPriceUpdate: {
      selector: '[data-bq="edit-request-update-price"]',
      options: $.extend({type: 'update', eventName: 'focusout', notificationInline: true, ajaxUrl: bq.urls.ajax.editRequestPriceUpdate, callbackSuccess: bq.callbacks.changeOrderPriceUpdateSuccess, callbackValidationFail: bq.callbacks.changeOrderQtyPriceValidationFail}, bq.messages.ajaxActions.cartqty)
  },
  approverEditRequestPriceUpdate: {
      selector: '[data-bq="approver-edit-request-update-price"]',
      options: $.extend({type: 'update', eventName: 'focusout', notificationInline: true, ajaxUrl: bq.urls.ajax.approverEditRequestPriceUpdate, callbackSuccess: bq.callbacks.changeOrderPriceUpdateSuccess, callbackValidationFail: bq.callbacks.changeOrderQtyPriceValidationFail}, bq.messages.ajaxActions.cartqty)
  },
  addSubscription: {
    selector: '[data-bq="add-subscription"]',
      options: $.extend({type: 'add', highlightSuccess: true, ajaxUrl: bq.urls.ajax.subscription, callbackSuccess: bq.callbacks.addSubscriptionSuccess,
          callAroundAjax: bq.callbacks.addSubscriptionAroundAjax, prepareAroundRequest: bq.callbacks.addSubscriptionPrepareRequest}, bq.messages.ajaxActions.cart)
  },
  oneClickRequest: {
    selector: '[data-bq="one-click-request"]',
    options: $.extend({type: 'add', highlightSuccess: true, ajaxUrl: bq.urls.ajax.oneClickRequest, callbackSuccess: bq.callbacks.oneClickRequestSuccess, prepareAroundRequest: bq.callbacks.oneClickPrepareRequest, callBeforeAjax: bq.callbacks.oneClickOneBeforeRequest, validationCallback: bq.callbacks.oneClickValidationRequest}, bq.messages.ajaxActions.oneClickRequest)
  },
  updateDefaultBilling: {
    selector: '[data-bq="update-default-billing"]',
    options: $.extend({type: 'update', highlightSuccess: true, ajaxUrl: bq.urls.ajax.updateDefaultLocation, callbackSuccess: bq.callbacks.updateDefaultLocationRequestSuccess, prepareAroundRequest: bq.callbacks.updateDefaultLocationPrepareRequest, callAroundAjax: bq.callbacks.updateDefaultLocationAroundAjax }, bq.messages.ajaxActions.defaultLocation.billing)
  },
  removeDefaultBilling: {
    selector: '[data-bq="remove-default-billing"]',
    options: $.extend({type: 'remove', highlightSuccess: true, ajaxUrl: bq.urls.ajax.removeDefaultLocation, callbackSuccess: bq.callbacks.updateDefaultLocationRequestSuccess}, bq.messages.ajaxActions.defaultLocation.billing)
  },
  updateDefaultShipping: {
    selector: '[data-bq="update-default-shipping"]',
    options: $.extend({type: 'update', highlightSuccess: true, ajaxUrl: bq.urls.ajax.updateDefaultLocation, callbackSuccess: bq.callbacks.updateDefaultLocationRequestSuccess, prepareAroundRequest: bq.callbacks.updateDefaultLocationPrepareRequest, callAroundAjax: bq.callbacks.updateDefaultLocationAroundAjax }, bq.messages.ajaxActions.defaultLocation.shipping)
  },
  approverUpdateSupplierPayment: {
    selector: '[data-bq="approver-update-supplier-payment-info"]',
    options: $.extend({type: 'update', highlightSuccess: true, ajaxUrl: bq.urls.ajax.approverUpdateSupplierPayment, callBeforeAjax: bq.callbacks.updateSupplierBeforeAjax, callBeforeAjaxUseInterval: true, callbackSuccess: bq.callbacks.updateSupplierPaymentInfoSuccess, validationCallback: bq.callbacks.updateSupplierPaymentValidation}, bq.messages.ajaxActions.supplierPayment)
  },
  updateSupplierPayment: {
    selector: '[data-bq="update-supplier-payment-info"]',
    options: $.extend({type: 'update', highlightSuccess: true, ajaxUrl: bq.urls.ajax.updateSupplierPayment, callBeforeAjax: bq.callbacks.updateSupplierBeforeAjax, callBeforeAjaxUseInterval: true, callbackSuccess: bq.callbacks.updateSupplierPaymentInfoSuccess, validationCallback: bq.callbacks.updateSupplierPaymentValidation}, bq.messages.ajaxActions.supplierPayment)
  },
  changeOrderUpdateSupplierPayment: {
    selector: '[data-bq="co-update-supplier-payment-info"]',
    options: $.extend({type: 'update', highlightSuccess: true, ajaxUrl: bq.urls.ajax.changeOrderUpdateSupplierPayment, callBeforeAjax: bq.callbacks.updateSupplierBeforeAjax, callBeforeAjaxUseInterval: true, callbackSuccess: bq.callbacks.updateSupplierPaymentInfoSuccess, validationCallback: bq.callbacks.updateSupplierPaymentValidation}, bq.messages.ajaxActions.supplierPayment)
  },
  removeDefaultShipping: {
    selector: '[data-bq="remove-default-shipping"]',
    options: $.extend({type: 'remove', highlightSuccess: true, ajaxUrl: bq.urls.ajax.removeDefaultLocation, callbackSuccess: bq.callbacks.updateDefaultLocationRequestSuccess}, bq.messages.ajaxActions.defaultLocation.shipping)
  }
};


bq.global.registerAjaxActions = function() {

  $.each(bq.global.ajaxActions.options, function(key, value) {
    var $options = value;

    $($options.selector).each(function() {
      var $el = $(this);
      if(!$el.data('bq.ajaxAction')) { //ignore if it already registered
        var tmpOptions = $.extend({}, $options.options);

        if($options.options.toggle) {

          if($el.is("input") && $el.prop('checked')) { //if its a checkbox and its checked, assign class and set toggle right
            tmpOptions.type = 'remove';
            tmpOptions.toggle = 'add';
            $el.parent().addClass('checked');
          }

          if($el.parent().hasClass('active')) { //if its parent has class active, set toggle right
            tmpOptions.type = 'remove';
            tmpOptions.toggle = 'add';
          }

        }

        var opt = $.extend({}, $el.data(), tmpOptions);
        $el.ajaxAction(opt);

      }
    });

  });
};

bq.init.push(bq.global.registerAjaxActions);
